import React from "react";
import classNames from "classnames";

export interface CheckboxProps extends React.HTMLProps<HTMLInputElement> {
  invalid?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  controlled?: boolean; // For when component is used in a React app
  isChecked?: boolean; // For when component is used in a React app
}

const Checkbox = ({
  label,
  id,
  invalid = false,
  controlled = false,
  disabled = false,
  isChecked,
  ...rest
}: CheckboxProps) => {
  return (
    <label className={classNames("checkbox", invalid && "checkbox--invalid")}>
      <input
        type="checkbox"
        id={id}
        name={id}
        className="checkbox__checkbox"
        checked={controlled ? isChecked : undefined}
        {...rest}
      />
      <span className="checkbox__custom-checkbox" aria-hidden="true"></span>
      <span className="checkbox__label">{label}</span>
    </label>
  );
};

export { Checkbox };
